import { render } from "./BudgetReport.vue?vue&type=template&id=3f8442be&scoped=true"
import script from "./BudgetReport.vue?vue&type=script&lang=js"
export * from "./BudgetReport.vue?vue&type=script&lang=js"

import "./BudgetReport.vue?vue&type=style&index=0&id=3f8442be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8442be"]])

export default __exports__